/*
 * @Author: Teemo Ding
 * @Date: 2022-01-17 10:15:20
 * @LastEditTime: 2022-03-17 09:38:59
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/BlocksInRowDisplay/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Form } from 'src/components/Antd';
import { get } from 'lodash';

const limited = ['voucherQuantity', 'limited'];
const Item = Form.Item;
const RowBlocks = (props) => {
  const { data = [] } = props;
  const len = (data || []).length;
  const fixedWidth = len < 4;

  return (
    <Item
      shouldUpdate={(p, c) => {
        const pV = get(p, limited);
        const cV = get(c, limited);
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const hasLimited = getFieldValue(limited);
        let arr = [];
        if (!hasLimited) {
          arr = data[2]
            ? [
                { hideBorder: true, ...data[2] },
                { hideBorder: true },
                { hideBorder: true },
              ]
            : [];
        } else {
          arr = data;
        }

        //
        return (
          <div className={css.container}>
            {(arr || []).map((i, index) => {
              const { title, amount, hideBorder } = i;
              if (index === len - 1) {
                return (
                  <Block
                    hideBorder
                    key={index}
                    fixedWidth={fixedWidth}
                    title={title}
                    amount={amount}
                  />
                );
              } else {
                return (
                  <Block
                    hideBorder={hideBorder}
                    key={index}
                    fixedWidth={fixedWidth}
                    title={title}
                    amount={amount}
                  />
                );
              }
            })}
          </div>
        );
      }}
    </Item>
  );
};
export const Block = (props) => {
  const { title, amount, fixedWidth, hideBorder } = props;

  return (
    <div
      className={`${css.block} ${hideBorder ? css.noBorder : ''}  ${
        fixedWidth ? css.fixedWidth : ''
      }`}>
      <div className={css.title}>{title}</div>
      <div className={css.content}>{amount}</div>
    </div>
  );
};

export default RowBlocks;
